import React from "react";
import { Link } from "react-router-dom";
import RightArrow from "../../components/SVG";

import bannerBG from "../../assets/img/slider/slider-bg.png";
import instructorImg from "../../assets/img/members/sliderimage.png";
import shapeImg1 from "../../assets/img/slider/shape-1-1.png";
import shapeImg2 from "../../assets/img/slider/shape-1-2.png";
import bannerImg from "../../assets/img/sap/banner.jpg";

const HomeBanner = () => {
  return (
    <div className="ed-slider-area p-relative">
      <div
        className="ed-slider-bg p-relative"
        style={{ backgroundImage: `url(${bannerBG})` }}
      >
        <div className="ed-slider-instructor-box d-none d-lg-block">
          <div>
            <span>
              <i>600+</i> Members
            </span>
            <img src={instructorImg} alt="" />
          </div>
        </div>
        <div className="ed-slider-shape-2 d-none d-xl-block">
          <img src={shapeImg2} alt="" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-6">
              <div className="ed-slider-content">
                <span
                  className="ed-slider-subtitle pb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".3s"
                >
                  Welcome to the Society of Aquaculture Professionals
                </span>
                <h1
                  className="ed-slider-title wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".4s"
                >
                  Championing Aquaculture <br />
                  Excellence in India
                </h1>
                <p
                  className="pb-25 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".5s"
                >
                  Society of Aquaculture Professionals was founded as a
                  not-for-profit,
                  <br />
                  non-governmental organization in 2003. SAP is the voice of
                  aquaculture
                  <br /> professionals in India and presently counts 600+ life
                  members. Its biennial <br />
                  conference Aqua India is a marquee event known for its
                  technical content, <br />
                  delivery and networking opportunities.{" "}
                  <Link
                    to="/mission"
                    className="underline underline-offset-4 text-blue-700 px-1 hover:text-blue-700 py-[10px]"
                  >
                    Read More
                  </Link>
                </p>
                <Link
                  className="ed-btn-dark wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                  to="/membership"
                >
                  Become a SAP Member Now
                  <i>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="ed-slider-thumb">
          <img src={bannerImg} alt="" />
          <div className="ed-slider-shape-1 d-none d-xl-block">
            <img src={shapeImg1} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomeBanner;
